export const navTrack = window.parent.navTrack !== undefined && window.parent.s !== undefined ? 
    window.parent.navTrack : 
    function () {console.log('navTrack or s is not defined')}
